"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Form = _interopRequireDefault(require("../components/Form"));

var Inline = function Inline(props) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "1",
    tablet: "1",
    only: "computer tablet"
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "14",
    tablet: "14",
    mobile: "16"
  }, /*#__PURE__*/_react["default"].createElement(_Form["default"], props)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "1",
    tablet: "1",
    only: "computer tablet"
  }));
};

var _default = Inline;
exports["default"] = _default;